import HTTP from '@api';

import { generateXHRError } from '@helpers';

export default {
  namespaced: true,
  state: {
    substrates: [],
    allSubstrates: [],
  },
  mutations: {
    setSubstrates(state, payload) {
      state.substrates = payload;
    },
    setAllSubstrates(state, payload) {
      state.allSubstrates = payload;
    },
  },
  actions: {
    async getSubstrates({ commit, rootState: { locations } }, {
      suffix = locations.suffix, name = null, pageNum = 1, pageSize = 10,
    }) {
      try {
        const { data } = await HTTP.get(`${suffix}/substrate`, {
          params: { name, pageNum, pageSize },
        });
        commit('setSubstrates', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async getAllSubstrates(
      { commit, rootState: { locations } },
      { suffix = locations.suffix } = {},
    ) {
      try {
        const { data } = await HTTP.get(`${suffix}/substrate/list`);
        commit('setAllSubstrates', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async createSubstrate({ rootState: { locations } }, {
      suffix = locations.suffix, name, abbreviation = null, color, paperThickness,
    }) {
      try {
        await HTTP.post(`${suffix}/substrate`, {
          name, abbreviation, color, paperThickness,
        });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async updateSubstrate({ rootState: { locations } }, {
      suffix = locations.suffix, name, color, paperThickness,
    }) {
      try {
        await HTTP.post(`${suffix}/substrate/${encodeURIComponent(name)}`, {
          color, paperThickness,
        });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },
  },
};
